import { render } from "./localizedText.vue?vue&type=template&id=38f91655&scoped=true&ts=true"
import script from "./localizedText.vue?vue&type=script&lang=ts"
export * from "./localizedText.vue?vue&type=script&lang=ts"

import "./localizedText.vue?vue&type=style&index=0&id=38f91655&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f91655"]])

export default __exports__